"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Placeholder = exports.ImageComponent = exports.IMAGE_SIZE = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
const IMAGE_SIZE = exports.IMAGE_SIZE = 100;
const PADDING = 3;
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  aspectRatio: '1',
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.spacing(1),
  boxSizing: 'border-box',
  height: `calc(${IMAGE_SIZE}px + ${theme.spacing(PADDING * 2)})`,
  margin: 'auto',
  padding: theme.spacing(PADDING, 0),
  position: 'relative',
  width: IMAGE_SIZE
}));
const ImageComponent = exports.ImageComponent = (0, _mui.styled)(_presentationComponents.Image)({
  objectFit: 'contain'
});
const Placeholder = exports.Placeholder = (0, _mui.styled)(Root)(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  height: `calc(${IMAGE_SIZE}px + ${theme.spacing(PADDING * 2)})`,
  justifyContent: 'center',
  width: IMAGE_SIZE,
  '& svg': {
    color: theme.palette.grey[200],
    fontSize: '3rem'
  }
}));
